import { IsOptional, Length } from 'class-validator';

export class ManufacturerCreateModel {
  @Length(3, 128)
  public name: string;

  @IsOptional()
  @Length(0, 36)
  public userId?: string;

  constructor(
    name: string,
    userId?: string
  ) {
    this.name = name;
    this.userId = userId;
  }
}
